export { default as DashboardLayout } from './Dashboard';
export { default as SidePanel } from './SidePanel/SidePanel';
export { default as RoomDetails } from './MainContent/RoomDetails';
export { default as ResourceList } from './MainContent/ResourceList';
export { default as RoomSettings } from './MainContent/RoomSettings';
export { default as DashboardContent } from './MainContent/DashboardContent';



// WEBPACK FOOTER //
// ./src/Layout/Dashboard/index.js